var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-16 pl-24 pr-24" }, [
    _c("div", { staticClass: "row d-flex align-items-end m-0" }, [
      _c(
        "div",
        { staticClass: "col-3 col-lg-3 pl-8 pr-16" },
        [
          _c("EpLabel", { staticClass: "form__label mb-0" }, [
            _vm._v(
              _vm._s(
                _vm.getTextByCountry(
                  _vm.countryCode,
                  "component_epPOPaymentHeader_poNo_title"
                )
              )
            )
          ])
        ],
        1
      ),
      _c("div", { staticClass: "col-3 col-lg-2 pl-16" }, [
        _c("div", { staticClass: "row m-0" }, [
          _c(
            "div",
            { staticClass: "col-6 col-lg-6 p-0" },
            [
              _c("EpLabel", { staticClass: "form__label mb-0" }, [
                _vm._v("Records")
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 col-lg-6" },
            [
              _c("EpLabel", { staticClass: "form__label mb-0" }, [
                _vm._v("Currency")
              ])
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "col-6 col-lg-7" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4 col-lg-3 text-right pr-24" },
            [
              _c("EpLabel", { staticClass: "form__label mb-0" }, [
                _vm._v("Amount")
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-8 col-lg-9 pl-24" },
            [
              _c("EpLabel", { staticClass: "form__label mb-0" }, [
                _vm._v("Company Name")
              ])
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }